export default __webpack_public_path__ + "static/uxUi-e4fcc7c182dab0ded07ae60813682642.jpg";